// Search form functionality
export function displaySearchForm() {
  const searchButton = document.querySelector('.search-button');
  const searchForm = document.querySelector('.search-form');
  const searchInput = searchForm.querySelector('input');

  let isVisible = false;

  // Toggle search on button click
  searchButton.addEventListener('click', (e) => {
    e.preventDefault(); // prevent form submission or link behavior
    if (!isVisible) {
      showSearch();
      searchInput.focus();
    } else {
      hideSearch();
    }
  });

  // Keep form visible if user types something
  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim()) {
      showSearch();
    }
  });

  // Handle Enter key submission
  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const searchTerm = searchInput.value.trim();
      if (searchTerm) {
        // go to search page
        window.location.href = window.location.origin + '/?s=' + searchTerm;
      }
    }
  });

  function showSearch() {
    searchForm.classList.add('visible');
    isVisible = true;
  }

  function hideSearch() {
    searchForm.classList.remove('visible');
    isVisible = false;
  }
}
